import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/_guards';
import { LoginComponent } from './pages/login/login.component';
import { RecadastramentoAtivosComponent } from './pages/recadastramento-ativos/recadastramento-ativos.component';
import { BensValoresComponent } from './pages/bens-valores/bens-valores.component';
import { HomeComponent } from './pages/home/home.component';
import {ParametrizacoesComponent} from "./pages/parametrizacoes/parametrizacoes.component";
import {RelatorioRecadastramentoComponent} from "./pages/relatorio-recadastramento/relatorio-recadastramento.component";
import {PosCampanhaRecadastramentoComponent} from "./pages/pos-campanha-recadastramento/pos-campanha-recadastramento.component";

import {
  AfastamentoELicencasComponent
} from "./pages/relatorio-srh/afastamento-e-licencas/afastamento-e-licencas.component";
import { BeneficiosComponent } from "./pages/relatorio-srh/beneficios/beneficios.component";
import {
  CertidaoAfastamentosFaltasAbonosComponent
} from "./components/relatorios-srh/certidao-afastamentos-faltas-abonos/certidao-afastamentos-faltas-abonos.component";
import {
  CertidaoAfastamentosLicencasComponent
} from "./components/relatorios-srh/certidao-afastamentos-licencas/certidao-afastamentos-licencas.component";
import {
  CertidaoFeriasNaoUsufruidasComponent
} from "./components/relatorios-srh/certidao-ferias-nao-usufruidas/certidao-ferias-nao-usufruidas.component";
import {
  CertidaoFeriasUsufruidasComponent
} from "./components/relatorios-srh/certidao-ferias-usufruidas/certidao-ferias-usufruidas.component";
import {
  CertidaoLicencaPremioNaoUsufruidaComponent
} from "./components/relatorios-srh/certidao-licenca-premio-nao-usufruida/certidao-licenca-premio-nao-usufruida.component";
import {
  CertidaoLicencaPremioUsufruidaComponent
} from "./components/relatorios-srh/certidao-licenca-premio-usufruida/certidao-licenca-premio-usufruida.component";
import { EscalaFeriasComponent } from "./components/relatorios-srh/escala-ferias/escala-ferias.component";
import {
  EscalaFeriasLotacaoComponent
}
from "./components/relatorios-srh/escala-ferias-lotacao/escala-ferias-lotacao.component";
import { FeriasComponent } from "./pages/relatorio-srh/ferias/ferias.component";
import {
  CertidaoContribuicaoPlanservComponent
} from "./components/relatorios-srh/certidao-contribuicao-planserv/certidao-contribuicao-planserv.component";
import {
  CertidaoContribuicaoSulamericaComponent
} from "./components/relatorios-srh/certidao-contribuicao-sulamerica/certidao-contribuicao-sulamerica.component";
import { FolgasCategoriasComponent } from "./components/relatorios-srh/folgas-categorias/folgas-categorias.component";
import { FolgasComponent } from "./pages/relatorio-srh/folgas/folgas.component";
import { SolicitacaoAuxilioSaudeComponent } from './pages/solicitacao-auxilio-saude/solicitacao-auxilio-saude.component';
import {
  InformacoesFuncionaisComponent
} from "./pages/relatorio-srh/informacoes-funcionais/informacoes-funcionais.component";
import {
  InformacoesFuncionaisCategoriasComponent
} from "./components/relatorios-srh/informacoes-funcionais-categorias/informacoes-funcionais-categorias.component";
import { ListaSolicitacoesComponent } from './pages/lista-solicitacoes/lista-solicitacoes.component';
import { VisualizarSolicitacaoComponent } from './pages/visualizar-solicitacao/visualizar-solicitacao.component';
import { DetalhesSolicitacaoComponent } from './pages/detalhes-solicitacao/detalhes-solicitacao.component';

const routes: Routes = [
  // Padrão para telas com base no perfil
  { path: 'solicitacao-auxilio-saude', component: SolicitacaoAuxilioSaudeComponent, canActivate:[AuthGuard]},
  { path: 'solicitacao-auxilio-saude/:id', component: SolicitacaoAuxilioSaudeComponent, canActivate:[AuthGuard]},
  { path: 'formularios-srh/auxilio-saude/lista-solicitacoes', component: ListaSolicitacoesComponent, canActivate:[AuthGuard]},
  { path: 'visualizar-solicitacao/:id', component: VisualizarSolicitacaoComponent, canActivate:[AuthGuard]},
  { path: 'detalhes-solicitacao/:id/:idPessoa', component: DetalhesSolicitacaoComponent, canActivate:[AuthGuard]},
  { path: 'bensValores', component: BensValoresComponent, canActivate:[AuthGuard]},
  { path: 'recadastramento', component: RecadastramentoAtivosComponent, canActivate:[AuthGuard]},
  { path: 'parametrizacoes', component: ParametrizacoesComponent, canActivate:[AuthGuard], data:{roles: ["M"]}},
  { path: 'relatorios', component: RelatorioRecadastramentoComponent, canActivate:[AuthGuard], data:{roles: ["M"]}},
  { path: 'relatorios-srh/beneficios',
   component: BeneficiosComponent,
   canActivate:[AuthGuard],
   children: [
    {
      path: 'certidao-contribuicao-planserv',
      component: CertidaoContribuicaoPlanservComponent,
      canActivate:[AuthGuard]
    },
    {
      path: 'certidao-contribuicao-sulamerica',
      component: CertidaoContribuicaoSulamericaComponent,
      canActivate:[AuthGuard]
    }
  ]

  },
  { path: 'relatorios-srh/informacoes-funcionais',
    component: InformacoesFuncionaisComponent,
    canActivate:[AuthGuard],
    children: [
      {
        path: 'categorias',
        component: InformacoesFuncionaisCategoriasComponent,
        canActivate:[AuthGuard]
      }
    ]

  },
  { path: 'relatorios-srh/ferias', component: FeriasComponent, canActivate:[AuthGuard],
    children: [
      {
        path: 'escala-ferias',
        component: EscalaFeriasComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'escala-ferias-lotacao',
        component: EscalaFeriasLotacaoComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'certidao-ferias-nao-usufruidas',
        component: CertidaoFeriasNaoUsufruidasComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'certidao-ferias-usufruidas',
        component: CertidaoFeriasUsufruidasComponent,
        canActivate:[AuthGuard]
      },
    ]
  },
  { path: 'relatorios-srh/folgas', component: FolgasComponent, canActivate:[AuthGuard],
    children: [
      {
        path: 'categorias',
        component: FolgasCategoriasComponent,
        canActivate:[AuthGuard]
      }
    ]
  },
  { path: 'relatorios-srh/afastamento-e-licencas',
    component: AfastamentoELicencasComponent,
    canActivate:[AuthGuard],
    children: [
      {
        path: 'certidao-afastamentos-faltas-abono',
        component: CertidaoAfastamentosFaltasAbonosComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'certidao-afastamentos-licencas',
        component: CertidaoAfastamentosLicencasComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'certidao-licenca-premio-nao-usufruida',
        component: CertidaoLicencaPremioNaoUsufruidaComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'certidao-licenca-premio-usufruida',
        component: CertidaoLicencaPremioUsufruidaComponent,
        canActivate:[AuthGuard]
      },

    ]
  },
  { path: 'posCampanha', component: PosCampanhaRecadastramentoComponent, canActivate:[AuthGuard], data:{roles: ["M"]}},
  { path: 'login', component: LoginComponent},
  { path: 'home',  component: HomeComponent, canActivate:[AuthGuard] },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
  providers: []
})
export class AppRoutingModule {

}
